import React from 'react'
import {
  DailyQuoteIcon,
  DailyQuoteMainText,
  DailyQuoteParentContainer,
  DailyQuoteSeparatorLine,
  DailyQuoteAuthorText,
} from './DailyQuoteStyles'
import quote_icon_white from 'src/assets/quote_icon_white.png'

export default function DailyQuote(props) {
  return (
    <DailyQuoteParentContainer>
      <DailyQuoteMainText>
        <DailyQuoteIcon src={quote_icon_white} />
      </DailyQuoteMainText>
      <DailyQuoteMainText>{props?.cardsData?.[0]?.dailyQuote?.msg}</DailyQuoteMainText>
      <DailyQuoteSeparatorLine />
      <DailyQuoteAuthorText>{props?.cardsData?.[0]?.dailyQuote?.author}</DailyQuoteAuthorText>
    </DailyQuoteParentContainer>
  )
}
